import React from 'react';

import { Feature } from 'components/Feature';
import EditUserAgenciesAgent from './EditUserAgenciesAgent';
import EditUserAgenciesInternal from './EditUserAgenciesInternal';

const EditUserAgenciesAgentSD = () => {
  return (
    <>
      <Feature allowed={'internalUser'}>
        <EditUserAgenciesInternal />
      </Feature>
      <Feature allowed={'isAgent'}>
        <EditUserAgenciesAgent />
      </Feature>
    </>
  );
};

export default EditUserAgenciesAgentSD;
